export const resolveEventFocusActivity = (
  event: wowaudit.Event,
  activities: wowaudit.EventActivity[],
): wowaudit.EventActivity | undefined => {
  const firstActive = activities.find((activity) => activity.active)

  if (event.primaryActivityId != null) {
    return (
      activities.find((activity) => activity.id === event.primaryActivityId) ??
      firstActive
    )
  }

  return firstActive
}
